import { Observable } from 'rxjs';

import { SessionInterface } from '../../domain/data';

export abstract class SessionClientInterface {
    abstract create(): Observable<SessionInterface>;
}
